import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
function BiometricArray(biometric) {
  return [
    {
      title: "BodyTemperature",
      value: biometric?.temperature || "NoInfo",
      testId: "single-biometric.temperature-value",
    },
    {
      title: "Puls/Min",
      value: biometric?.heartRate || "NoInfo",
      testId: "single-biometric.heart-rate-value",
    },
    {
      title: "Mass",
      value: biometric?.weight || "NoInfo",
      testId: "single-biometric.weight-value",
    },
    {
      title: "FrequencyOfBreathing",
      value: biometric?.breathingFrequency || "NoInfo",
      testId: "single-biometric.breathing-frequency-value",
    },
    {
      title: "length",
      value: biometric?.length || "NoInfo",
      testId: "single-biometric.length-value",
    },
    {
      title: "height",
      value: biometric?.height || "NoInfo",
      testId: "single-biometric.height-value",
    },
  ];
}
export default function SingleBiometric({ biometric, paper = true }) {
  const { t } = useTranslation();

  const vaccinationDetails = BiometricArray(biometric);

  function SingleDetail({ data }) {
    return (
      <Grid item xs={12} md={6}>
        <Typography variant="caption" color={"GrayText"}>
          {t(data?.title)}
        </Typography>
        <Typography data-testid={data?.testId}>{t(data?.value)}</Typography>
      </Grid>
    );
  }

  if (!paper) {
    return (
      <Grid container spacing={1}>
        {vaccinationDetails?.map((vaccine) => (
          <SingleDetail key={vaccine.title} data={vaccine} />
        ))}
      </Grid>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={1}>
        {vaccinationDetails?.map((vaccine) => (
          <SingleDetail key={vaccine.title} data={vaccine} />
        ))}
      </Grid>
    </Paper>
  );
}
